/**
 * @file     prompts.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the prompt system's surfaces: the first-time
 *           buyer call offer (card, bar, in-page link), its booking sheet, and
 *           the get-the-app panels.
 */
export const prompts = {
  notNow: 'Not now',
  offer: {
    region: 'Free call with Ray Rasouli',
    headline: {
      default: 'Talk through your first purchase',
      result: 'Talk through your {{amount}} budget',
      listing: 'Talk through this home and your budget',
    },
    line: 'A free one-hour call about your budget and next steps.',
    credential: 'REALTOR®',
    timesLabel: 'Next open times',
    barLine: 'Free call · {{slot}}',
    link: 'Book a call with Ray Rasouli',
    timeChip: '{{day}}, {{time}}',
  },
  sheet: {
    label: 'Book a call with Ray Rasouli',
    subtitle: 'Free one-hour call',
    step: 'Step {{n}} of 2',
    pickTitle: 'Pick a time',
    continue: 'Continue',
    detailsTitle: 'Your details',
    change: 'Change',
    slot: '{{slot}} Pacific',
    noSlots: 'No open times this week.',
    nextWeek: 'See next week',
    done: 'Done',
    consentAction: 'booking',
    sending: 'Sending',
    back: 'Back',
    close: 'Close',
  },
  app: {
    region: 'Get the Relta app',
    title: 'Get the Relta app',
    line: 'Search homes and get alerts on your phone.',
    scan: 'Scan with your phone camera.',
    qr: 'QR code that opens the Relta app in the store',
    appStore: 'Download on the App Store',
    googlePlay: 'Get it on Google Play',
  },
} as const;
